import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class OfferAccessorial extends Component {
  render() {
    const {
      accessorial: {
        description,
        picture_url,
      },
    } = this.props;

    return (
      <div className="offer-accessorial">
        <img
          src={picture_url}
          alt={description}
        />
        <p style={{marginBottom:3}}>
          <small>{description}</small>
        </p>
      </div>
    );
  }
}

OfferAccessorial.propTypes = {
  accessorial: PropTypes.shape({
    description: PropTypes.string.isRequired,
    picture_url: PropTypes.string.isRequired,
  }).isRequired,
};
